module.exports = __webpack_public_path__ + "img/_Kiln-Calendar-Graphic.4730f649.gif";